





































































import Modal from "../core/Modals/Modal.vue";
import PhotosViewer from "../core/Files/PhotosViewer.vue";
import MailEditor from "../core/Forms/MailEditor.vue";
import moment from "moment";
import "moment/locale/fr";
import StringUtils from "../utils/StringUtils";
import { EmailApi } from "../api/EmailApi";
import { Email } from "../models/Email";
import { FileApi } from "../api/FileApi";
import { SettingApi } from "../api/SettingApi";
import { Setting } from "../models/Setting";
import FileUploader from "../core/Forms/FileUploader.vue";
import { Contact } from "../models/Contact";

moment.locale("fr");

export default {
    name: "BonDePassageModal",
    components: { FileUploader, PhotosViewer, Modal, MailEditor },
    props: {
        showModal: Boolean,
        interventions: Array,
    },
    data() {
        return {
            step: 0,
            saving: false,
            photos: [],
            emailData: {
                to: "",
                subject: "",
                body: "",
                bodies: [
                    {
                        text: "",
                        editable: false,
                    },
                    {
                        text: "",
                        editable: true,
                    },
                    {
                        text: "",
                        editable: false,
                    },
                    {
                        text: "",
                        editable: true,
                    },
                ],
                attachments: [],
                photos: [],
                reference: null,
                type_notification: Email.ETypeNotification.Email,
                save_type_notification:
                    Email.ESaveTypeNotification.Intervention,
            },
            defaultContact: null,
            defaultContactRole: Contact.ERole.statut_intervention,
            EmailApi: new EmailApi(),
            FileApi: new FileApi(),
            SettingApi: new SettingApi(),
        };
    },
    methods: {
        nextStep(): void {
            let self = this;

            self.step++;
            if (this.step === 1) {
                _.each(self.photos, function (photos, interventionId) {
                    _.each(photos, function (photo) {
                        photo.shared = !!photo.selected;
                        self.FileApi.updatePhoto(photo);
                    });
                });

                let client = _.chain(self.interventions)
                    .map("client")
                    .flatten()
                    .first()
                    .value();

                if (client) {
                    self.defaultContact = client;
                } else {
                    self.defaultContact = null;
                }

                self.emailData.subject = client ? client.nom : "";

                self.SettingApi.get(
                    Setting.settingsKeys.mail_bon_de_passage_template
                ).then(function (setting) {
                    let body = StringUtils.replaceMailParams(setting.value);
                    let bodies = _.split(body, "{status_interventions}");

                    if (self.interventions[0].client) {
                        self.emailData.bodies[0].text =
                            "<h4 style='background-color: darkgray; color: white; border: solid darkgray 10px;'>&nbsp;" +
                            self.interventions[0].client.nom +
                            "</h4>";
                    }

                    self.emailData.bodies[1].text = bodies[0];

                    self.emailData.bodies[2].text = "";
                    _.forEach(self.interventions, function (intervention) {
                        self.emailData.bodies[2].text +=
                            intervention.statusHtml;
                    });

                    if (bodies.length > 1) {
                        self.emailData.bodies[3].text = bodies[1];
                    } else {
                        self.emailData.bodies[3].text = "";
                    }
                });
            }
        },
        // Events
        closeModal(): void {
            this.saving = false;
            this.step = 0;
            this.$emit("close-modal");
        },
        updateMailData: function (emailData) {
            this.emailData.to = emailData.to;
            this.emailData.subject = emailData.subject;
            this.emailData.body = emailData.body;
            this.emailData.recipient = emailData.recipient;
        },
        updateFilesList: function (filesIds: Array<Number>): void {
            this.emailData.attachments = filesIds;
        },
        updatePhotosList: function (photoIds: Array<Number>): void {
            this.emailData.photos = photoIds;
        },
        onUploadStart: function () {
            this.saving = true;
        },
        onUploadEnd: function () {
            this.saving = false;
        },
        sendMail() {
            let self = this;

            if (
                !self.emailData.to ||
                !StringUtils.isValidEmailList(self.emailData.to) ||
                self.saving
            )
                return;

            self.saving = true;

            self.EmailApi.create(self.emailData).then(function (res) {
                self.closeModal();
            });
        },
    },
    watch: {
        showModal: function (val: boolean) {
            if (val && this.interventions.length > 0) {
                this.emailData.reference = _.first(this.interventions).id;

                this.photos = _.chain(this.interventions)
                    .groupBy("id")
                    .mapValues(_.head)
                    .mapValues("photos")
                    .value();

                if (_.flatMap(this.photos).length < 1) {
                    this.nextStep();
                } else {
                    this.step = 0;
                }
            }
        },
    },
};
